// TODO: is this specific to a page? move to template or lib file and include in script-tags.liquid
function toggleMenuMb() {
  let accordionMbMenu3 = document.querySelectorAll(
    ".level-2 .mobile-nav__item--2.has-child .mobile-nav__link"
  );

  accordionMbMenu3.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.target.parentElement.classList.remove("is-active");
      e.target.parentElement.classList.toggle("is-open");
    });
  });
}


// TODO: can this be moved to lib.read-more.js?
const SeeMore = (() => {
  let s;

  return {
    settings() {
      return {
        content: document.querySelectorAll(".js-see-more"),
        originalContentArr: [],
        truncatedContentArr: [],
        moreLink: "See More",
        lessLink: "See Less",
      };
    },

    init() {
      s = this.settings();
      this.bindEvents();
    },

    bindEvents() {
      SeeMore.truncateText();
    },

    countWords(str) {
      return str.split(/\s+/).length;
    },

    ellipseContent(str, wordsNum) {
      return str.split(/\s+/).slice(0, wordsNum).join(" ") + "...";
    },

    truncateText() {
      for (let i = 0; i < s.content.length; i++) {
        s.content[i].querySelectorAll("span, p, strong").forEach(el => {
          el.textContent.trim() === "" && el.parentNode.removeChild(el)
        })
        const originalContent = s.content[i].innerHTML;
        const numberOfWords = s.content[i].dataset.rmWords / 2;
        const truncateContent = SeeMore.ellipseContent(
          originalContent,
          numberOfWords
        );

        const originalContentWords = SeeMore.countWords(originalContent);
        s.originalContentArr.push(originalContent);
        s.truncatedContentArr.push(truncateContent);

        if (numberOfWords < originalContentWords) {
          s.content[i].innerHTML = s.truncatedContentArr[i];
          let self = i;
          SeeMore.createLink(self);
        }
      }
      SeeMore.handleClick(s.content);
    },

    createLink(index) {
      const linkWrap = document.createElement("span");

      linkWrap.className = "read-more__link-wrap";

      linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;
      // Inset created link
      s.content[index].parentNode.insertBefore(
        linkWrap,
        s.content[index].nextSibling
      );
    },

    handleClick(el) {
      const readMoreLink = document.querySelectorAll(".read-more__link");

      for (let j = 0, l = readMoreLink.length; j < l; j++) {
        readMoreLink[j].addEventListener("click", function () {
          const moreLinkID = this.getAttribute("id");
          let index = moreLinkID.split("_")[1];

          el[index].classList.toggle("is-enlarged");

          if (this.dataset.clicked !== "true") {
            el[index].innerHTML = s.originalContentArr[index];
            this.innerHTML = s.lessLink;
            this.dataset.clicked = true;
          } else {
            el[index].innerHTML = s.truncatedContentArr[index];
            this.innerHTML = s.moreLink;
            this.dataset.clicked = false;
          }
        });
      }
    },

    openAll() {
      const instances = document.querySelectorAll(".read-more__link");
      for (let i = 0; i < instances.length; i++) {
        content[i].innerHTML = s.truncatedContentArr[i];
        instances[i].innerHTML = s.moreLink;
      }
    },
  };
})();
SeeMore.init();

// TODO: can this be moved to lib.shopify-theme-sections.js?

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
toggleMenuMb();

function initThemeInteractions() {
  // .site-header has no click listener of its own; the synthetic click bubbles up to
  // the document-level handler that dismisses the search autocomplete overlay.
  function dismissSearchOverlay() {
    const header = document.querySelector(".site-header");
    if (header) header.click();
  }

  function swatchFormFocusables() {
    return [
      ...document.querySelectorAll(
        ".pdp-product-form a, .pdp-product-form button, .pdp-product-form input, .pdp-product-form label"
      ),
      ...document.querySelectorAll(
        ".pdp-buybox__content a, .pdp-buybox__content button, .pdp-buybox__content input"
      ),
    ];
  }

  function showSwatchRequestForm() {
    const anchor = document.getElementById("js-swatch-anchor");
    // The markup ships with inline display:none, so an explicit value is needed here.
    if (anchor) anchor.style.display = "block";

    document.querySelectorAll(".modal-overlay").forEach((el) => el.classList.add("is-show"));
    document.body.classList.add("overflow-hidden");

    swatchFormFocusables().forEach((el) => el.setAttribute("tabindex", "2"));
  }

  function hideSwatchRequestForm() {
    const anchor = document.getElementById("js-swatch-anchor");
    if (anchor) anchor.style.display = "none";

    document.querySelectorAll(".modal-overlay").forEach((el) => el.classList.remove("is-show"));
    document.body.classList.remove("overflow-hidden");

    const trigger = document.querySelector(".swatch__link-handle");
    if (trigger) trigger.focus();

    swatchFormFocusables().forEach((el) => el.removeAttribute("tabindex"));
  }

  // Handlers are delegated on document so they survive section re-renders.
  document.addEventListener("click", function (event) {
    // Product page
    const tab = event.target.closest(".content__tab");
    if (tab) {
      document
        .querySelectorAll(".content__tab-active")
        .forEach((el) => el.classList.remove("content__tab-active"));
      tab.classList.add("content__tab-active");

      document
        .querySelectorAll(".accordion__panel--active")
        .forEach((el) => el.classList.remove("accordion__panel--active"));

      const panel = document.getElementById(tab.getAttribute("data-tab"));
      if (panel) panel.classList.add("accordion__panel--active");
      return;
    }

    const innerTab = event.target.closest(".inner_content__tab");
    if (innerTab) {
      const panel = document.getElementById(innerTab.getAttribute("data-tab"));

      if (innerTab.classList.contains("inner_content__tab-active")) {
        innerTab.classList.remove("inner_content__tab-active");
        innerTab.setAttribute("aria-expanded", "false");
        innerTab.textContent = "See More";
        if (panel) {
          panel.classList.remove("inner_accordion__panel--active");
          panel.setAttribute("aria-hidden", "true");
        }
      } else {
        innerTab.classList.add("inner_content__tab-active");
        innerTab.setAttribute("aria-expanded", "true");
        innerTab.textContent = "See Less";
        if (panel) {
          panel.classList.add("inner_accordion__panel--active");
          panel.setAttribute("aria-hidden", "false");
        }
      }
      return;
    }

    if (event.target.closest(".swatch__link-handle")) {
      showSwatchRequestForm();
      return;
    }

    if (
      event.target.closest("#js-swatch-anchor .btn-close") ||
      event.target.closest(".modal-overlay")
    ) {
      hideSwatchRequestForm();
      return;
    }

    // Account page
    // This prevents the accordion from firing when clicking links inside account sidebar menu.
    const sidebar = event.target.closest(".account-sidebar");
    if (sidebar && event.target.closest("li")) {
      sidebar.querySelectorAll(".account-nav").forEach((el) => el.classList.remove("opened"));
      return;
    }

    // Sku
    const sku = event.target.closest("#reference-sku");
    if (sku) sku.classList.toggle("show-full-sku");
  });

  // Global Search
  // Remove auto search overlay when clicking on it.
  // SearchSpring stops propagation on its own container, so this has to listen in the
  // capture phase — a bubble-phase delegated handler never receives the event.
  document.addEventListener(
    "click",
    function (event) {
      if (event.target.closest && event.target.closest(".ss__autocomplete--target")) {
        dismissSearchOverlay();
      }
    },
    true
  );

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    hideSwatchRequestForm();

    const klaviyoFrame = document.getElementById("klaviyo-bis-iframe");
    if (klaviyoFrame) klaviyoFrame.style.display = "none";

    dismissSearchOverlay();
  });

  if (document.querySelector(".editorial-slider")) {
    tns({
      container: ".editorial-slider",
      items: 1,
      slideBy: "page",
      swipeAngle: false,
      navPosition: "bottom",
      nav: true,
      responsive: {
        768: {
          items: 1,
          nav: false,
        },
      },
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initThemeInteractions);
} else {
  initThemeInteractions();
}